<section class="dashboard-main container-fluid">
    <div class="contents-main">
        <div class="card table-card">
            <div class="table-toolbar">
                <h1 class="table-toolbar__title">Region & City</h1>
                <div class="sb-filter-holder sb-filter-holder--inline">
                    <div class="btn-group sb-filter-search-group" role="group">
                        <input type="text" class="sb-filter-field sb-filter-search-input" placeholder="Search"
                            (input)="searchData($event)">
                        <button type="button" class="btn sb-filter-search-btn">
                            <!-- <i class="ri-search-line"></i> -->
                            <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 20 20"
                                fill="none">
                                <path
                                    d="M9.16667 15.8333C12.8486 15.8333 15.8333 12.8486 15.8333 9.16667C15.8333 5.48477 12.8486 2.5 9.16667 2.5C5.48477 2.5 2.5 5.48477 2.5 9.16667C2.5 12.8486 5.48477 15.8333 9.16667 15.8333Z"
                                    stroke="currentColor" stroke-width="1.5" stroke-linecap="round"
                                    stroke-linejoin="round" />
                                <path d="M17.5 17.5L13.875 13.875" stroke="currentColor" stroke-width="1.5"
                                    stroke-linecap="round" stroke-linejoin="round" />
                            </svg>
                        </button>
                    </div>
                    <button type="button" class="btn btn-dark rounded" (click)="addTariffPopUp(content)"
                        *ngIf="permissionsReady && permissions.canAdd">
                        <i class="ri-add-line label-icon align-middle fs-16"></i>
                        Add New
                    </button>
                </div>
            </div>
            <div class="card table-card">
                <!-- .table-wrap is position:relative, so the loader below is
                     bounded to the table instead of covering the whole page
                     (header, breadcrumb, toolbar) on every search keystroke
                     or filter change. -->
                <div class="table-wrap" [class.is-loading]="loader">
                    <div class="loaderwrapper" *ngIf="loader">
                        <span class="loader"></span>
                    </div>
                    <div class="table-main">
                        <div>
                            <table class="table-data">
                                <thead>
                                    <tr>
                                        <th scope="col">Sr. No</th>
                                        <th scope="col">City</th>
                                        <th scope="col">Region</th>
                                        <th scope="col" style="width: 80px; text-align: center"
                                            *ngIf="hasAnyActionPermission">Actions</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    <tr *ngFor="let item of citiesList; let i = index">
                                        <td>{{ item.srNo }}</td>

                                        <td>{{ item.name }}</td>
                                        <td>{{ item.region_name }}</td>

                                        <td *ngIf="hasAnyActionPermission">
                                            <ul class="list-inline hstack gap-2 mb-0">
                                                <li class="list-inline-item edit" data-bs-toggle="tooltip"
                                                    data-bs-trigger="hover" data-bs-placement="top" title="Edit">
                                                    <a title="Edit Teriff Type"
                                                        (click)="openEditPopUp(item, contentupdate)"
                                                        *ngIf="permissionsReady && permissions.canEdit"
                                                        class=" d-inline-block edit-item-btn" data-toggle="modal"
                                                        data-target="#edit-category-vt">
                                                        <!-- <i class="ri-pencil-fill fs-16"></i> -->
                                                        <svg width="15" height="15" viewBox="0 0 15 15" fill="none"
                                                            xmlns="http://www.w3.org/2000/svg">
                                                            <path
                                                                d="M14.4271 2.55876L12.4231 0.55468C12.0535 0.198814 11.5605 0 11.0475 0C10.5344 0 10.0414 0.198814 9.67183 0.55468L8.19147 2.05599L1.62759 8.59194C1.5773 8.64607 1.5392 8.71036 1.51586 8.78048L0.0773974 13.1098C0.0317216 13.2354 0.00580956 13.3673 0.000586046 13.5009C0.000586046 13.5009 0.000586046 13.5009 0.000586046 13.5428C-0.0066797 13.7872 0.0537341 14.0288 0.175157 14.2411C0.175157 14.2411 0.217054 14.2899 0.23102 14.3179C0.281294 14.4043 0.342295 14.4841 0.412574 14.5553C0.542741 14.6881 0.698117 14.7936 0.869587 14.8655C1.04106 14.9374 1.22517 14.9744 1.41112 14.9743C1.56556 14.9732 1.71882 14.9473 1.86501 14.8975L6.19437 13.459C6.26482 13.433 6.32904 13.3926 6.38291 13.3403L12.9258 6.79036L14.4271 5.28207C14.6123 5.10028 14.7585 4.88272 14.857 4.64263C14.9554 4.40255 15.004 4.14495 14.9997 3.8855C14.9874 3.38589 14.7822 2.91043 14.4271 2.55876ZM6.0198 12.237L4.37883 10.603L2.73786 8.96203L8.53363 3.17325L11.8156 6.4482L6.0198 12.237ZM1.52285 13.9268H1.39017C1.32518 13.9222 1.26255 13.9006 1.20862 13.864C1.14263 13.799 1.10286 13.712 1.09689 13.6196C1.09068 13.5756 1.09068 13.5309 1.09689 13.4869L1.20862 12.9423L2.03958 13.7732L1.52285 13.9268ZM3.14985 13.3892L1.59268 11.832L2.22811 9.93265L3.62468 11.3292L5.02125 12.7258L3.14985 13.3892ZM13.687 4.56982L12.5557 5.70802L9.27381 2.42608L10.412 1.29486C10.5808 1.12686 10.8093 1.03254 11.0475 1.03254C11.2856 1.03254 11.5141 1.12686 11.6829 1.29486L13.687 3.29894C13.855 3.46775 13.9493 3.69622 13.9493 3.93438C13.9493 4.17254 13.855 4.40101 13.687 4.56982Z"
                                                                fill="currentColor" />
                                                        </svg>
                                                    </a>
                                                </li>
                                                <li class="list-inline-item delete" data-bs-toggle="tooltip"
                                                    data-bs-trigger="hover" data-bs-placement="top" title="Delete"
                                                    *ngIf="permissionsReady && permissions.canDelete">
                                                    <a title="Delete City" data-bs-toggle="modal"
                                                        class=" d-inline-block edit-item-btn" type="button"
                                                        (click)="deleteTariffType(item.id,modalDelete)">
                                                        <svg width="15" height="18" viewBox="0 0 15 18" fill="none"
                                                            xmlns="http://www.w3.org/2000/svg">
                                                            <path
                                                                d="M4.40379 18C3.70982 17.9934 3.04372 17.7246 2.53781 17.2468C2.0319 16.7691 1.72321 16.1175 1.67308 15.4214L1.06533 6.68095C1.05986 6.59849 1.0706 6.51575 1.09693 6.43747C1.12326 6.35919 1.16466 6.28688 1.21878 6.22469C1.27289 6.16249 1.33866 6.11163 1.41232 6.075C1.48599 6.03836 1.5661 6.01668 1.6481 6.01118C1.7301 6.00568 1.81237 6.01648 1.89022 6.04296C1.96806 6.06943 2.03996 6.11107 2.10181 6.16549C2.16366 6.21991 2.21424 6.28604 2.25067 6.36012C2.2871 6.4342 2.30866 6.51477 2.31413 6.59723L2.90523 15.3377C2.93474 15.7226 3.10845 16.0819 3.39126 16.343C3.67406 16.6041 4.04487 16.7475 4.42876 16.7442L10.7144 16.6688C11.0963 16.6651 11.4624 16.5148 11.7378 16.2487C12.0132 15.9826 12.1772 15.6208 12.1963 15.2372L12.6875 6.59723C12.7003 6.43068 12.7769 6.27562 12.9011 6.16474C13.0254 6.05386 13.1876 5.9958 13.3535 6.00281C13.5177 6.01358 13.6711 6.08911 13.7802 6.21296C13.8893 6.33681 13.9454 6.49898 13.9363 6.6642L13.4451 15.3126C13.4032 16.0117 13.1004 16.6693 12.5972 17.1536C12.094 17.6379 11.4275 17.9133 10.731 17.9247L4.44541 18H4.40379ZM9.98176 9.71164C9.9796 9.54578 9.91313 9.38733 9.79649 9.27004C9.67986 9.15275 9.52229 9.0859 9.35736 9.08373H5.64426C5.47866 9.08373 5.31984 9.14989 5.20274 9.26764C5.08565 9.3854 5.01986 9.54511 5.01986 9.71164C5.01986 9.87817 5.08565 10.0379 5.20274 10.1556C5.31984 10.2734 5.47866 10.3395 5.64426 10.3395H9.35736C9.44075 10.3418 9.52374 10.3272 9.60142 10.2966C9.67911 10.2661 9.74993 10.2202 9.80968 10.1617C9.86944 10.1031 9.91693 10.0332 9.94934 9.95586C9.98176 9.87857 9.99844 9.79552 9.99841 9.71164H9.98176ZM9.33238 12.8093C9.33238 12.6428 9.2666 12.4831 9.1495 12.3653C9.0324 12.2476 8.87359 12.1814 8.70798 12.1814H6.29364C6.12804 12.1814 5.96922 12.2476 5.85212 12.3653C5.73502 12.4831 5.66924 12.6428 5.66924 12.8093C5.66924 12.9758 5.73502 13.1355 5.85212 13.2533C5.96922 13.3711 6.12804 13.4372 6.29364 13.4372H8.70798C8.87292 13.435 9.03048 13.3682 9.14712 13.2509C9.26375 13.1336 9.33023 12.9752 9.33238 12.8093ZM14.9936 4.41211C14.9734 4.56152 14.8996 4.69837 14.7862 4.79701C14.6728 4.89565 14.5275 4.94931 14.3775 4.94792H14.286C9.79197 4.32685 5.23463 4.32685 0.740639 4.94792C0.65803 4.96227 0.573408 4.95997 0.491691 4.94115C0.409974 4.92233 0.332791 4.88737 0.264625 4.83829C0.19646 4.78922 0.138673 4.72701 0.0946194 4.65529C0.0505662 4.58356 0.0211261 4.50375 0.00800961 4.42048C-0.0184104 4.25618 0.0211166 4.08806 0.117904 3.95305C0.214692 3.81804 0.360821 3.7272 0.52418 3.70048C0.63241 3.70048 1.78131 3.49956 3.5879 3.35723L3.88762 1.78328C3.98274 1.28084 4.24947 0.827616 4.64168 0.501991C5.0339 0.176366 5.52694 -0.00119065 6.03555 2.49695e-05H8.9744C9.48681 -0.00243268 9.98373 0.176603 10.378 0.505736C10.7723 0.834868 11.0387 1.29308 11.1307 1.80002L11.4137 3.35723C12.4044 3.44095 13.4201 3.54142 14.4608 3.70048C14.5424 3.71178 14.6209 3.73918 14.6919 3.78112C14.7629 3.82305 14.8249 3.87869 14.8744 3.94483C14.9239 4.01097 14.96 4.08631 14.9804 4.1665C15.0009 4.2467 15.0054 4.33017 14.9936 4.41211ZM7.1345 3.2149H10.115L9.89851 2.02607C9.85956 1.81024 9.74659 1.61497 9.57927 1.47424C9.41194 1.33351 9.20085 1.25623 8.98272 1.25584H6.04388C5.82593 1.25552 5.61463 1.33132 5.44609 1.47027C5.27754 1.60922 5.1622 1.80272 5.11977 2.0177L4.89498 3.2149H7.1345Z"
                                                                fill="currentColor" />
                                                        </svg>
                                                    </a>
                                                </li>
                                            </ul>
                                        </td>
                                    </tr>
                                    <!-- NO VIEW PERMISSION -->
                                    <tr *ngIf="permissionsReady && !permissions.canView">
                                        <td colspan="100%">
                                            <div class="no-access text-center p-4">
                                                You don’t have permission to view this data.
                                            </div>
                                        </td>
                                    </tr>

                                    <!-- NO RECORDS -->
                                    <tr
                                        *ngIf="permissionsReady && permissions.canView && (!citiesList || citiesList.length === 0)">
                                        <td colspan="100%">
                                            <p class="not-found-message p-4 text-center">
                                                No records found.
                                            </p>
                                        </td>
                                    </tr>
                                </tbody>
                            </table>
                        </div>
                        <div class="table-meta">
                            <div class="entries flex-column align-items-start gap-3">
                                <label class="show-entries-list p-0">
                                    Show
                                    <select [formControl]="pageSizeControl" class="form-control form-control-sm"
                                        (change)="changePageSize()">
                                        <option *ngFor="let limit of pageRecordOptions" [value]="limit.value">
                                            {{ limit.label }}
                                        </option>
                                    </select>
                                    Entries
                                </label>
                                <span>Total Records: {{this.total_items }}</span>
                            </div>
                            <nav class="table-pagination">
                                <ul>
                                    <li>
                                        <div class="go-to-page d-flex align-items-center">
                                            <label>Go to Page:</label>
                                            <input type="number" class="form-control form-control-sm"
                                                [(ngModel)]="pageToGo" min="1" [max]="total_pages"
                                                (keydown.enter)="goToPage(pageToGo); pageToGo = null">
                                            <div class="input-group-append">
                                                <button class="btn btn-primary" type="button"
                                                    (click)="goToPage(pageToGo); pageToGo = null"
                                                    [disabled]="pageToGo < 1 || pageToGo > total_pages">Go</button>
                                            </div>
                                        </div>
                                    </li>
                                    <li><a class="init-bg" id="firstPage" (click)="goToPage(1)"
                                            [class.disabled]="current_page === 1">1</a></li>
                                    <li><a class="no-bg" id="prevPage" (click)="navigatePage('prev')"><i
                                                class="fa fa-chevron-left"></i></a></li>
                                    <li><a class="active">{{ current_page }}</a></li>
                                    <li><a class="no-bg" id="nextPage" (click)="navigatePage('next')"
                                            [class.disabled]="current_page === total_pages"><i
                                                class="fa fa-chevron-right"></i></a></li>
                                    <li><a class="init-bg" id="lastPage" (click)="goToPage(total_pages)"
                                            [class.disabled]="current_page === total_pages">{{this.total_pages}}</a>
                                    </li>
                                </ul>
                            </nav>

                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</section>

<ng-template #content let-c="close" let-d="dismiss">
    <form [formGroup]="addCItyForm" (ngSubmit)="onAddCity()">
        <div class="modal-header">
            <h4 class="modal-title" id="modal-basic-title">Add City</h4>
            <button type="button" class="btn-close" aria-label="Close" (click)="d('Cross click'); resetForm()">
                <!-- <svg xmlns="http://www.w3.org/2000/svg" width="24" height="25" viewBox="0 0 24 25" fill="none">
                    <rect y="0.696289" width="24" height="24" rx="12" fill="white" />
                    <path d="M6.99988 7.69653L12.0514 12.748L17.1029 7.69653" stroke="currentColor" stroke-width="1.6"
                        stroke-linecap="round" stroke-linejoin="round" />
                    <path d="M6.99995 18.3679L12.0505 13.3164L17.1021 18.3679" stroke="currentColor" stroke-width="1.6"
                        stroke-linecap="round" stroke-linejoin="round" />
                </svg> -->
            </button>
        </div>

        <div class="modal-body">
            <div class="row">
                <div class="col-md-12 form-styles my-3">
                    <label for="region">Region <span class="text-danger">*</span></label>
                    <ng-select formControlName="region" id="region" [loading]="regionLoading"
                        loadingText="Loading regions...">
                        <ng-option *ngFor="let region of regionList" [value]="region.id">
                            {{ region.name }}
                        </ng-option>
                    </ng-select>
                    <small class="text-danger" *ngIf="
                            !addCItyForm.get('region').valid &&
                            addCItyForm.get('region').touched">
                        Please Select a Region</small>
                </div>
                <div class="col-md-12 mb-3 form-styles">
                    <label for="typeahead-basic">City <span class="text-danger">*</span></label>
                    <input id="typeahead-basic" type="text" class="form-control" formControlName="city"
                        maxlength="50" />
                    <small class="text-danger" *ngIf="
                            addCItyForm.get('city').hasError('required') &&
                            addCItyForm.get('city').touched
                        ">Please Enter City</small>
                    <small class="text-danger" *ngIf="!addCItyForm.get('city').hasError('required') &&
                                addCItyForm.get('city').hasError('leadingWhitespace') &&
                                addCItyForm.get('city').touched">
                        City cannot be a empty.
                    </small>
                    <small class="text-danger" *ngIf="addCItyForm.get('city').errors?.invalidInput">
                        City cannot be whitespace or only numbers.
                    </small>
                    <small class="text-danger" *ngIf="addCItyForm.get('city').errors?.pattern">
                        City can only contain alphabetic characters.
                    </small>
                </div>
            </div>
        </div>
        <div class="modal-footer no-bg">
            <button type="button" class="btn btn-outline-dark" aria-label="Close"
                (click)="d('Cross click'); resetForm()">
                Cancel
            </button>
            <button type="button" class="btn btn-orange" [disabled]="addCItyForm.invalid" (click)="d('Cross click')"
                type="submit">
                Save
            </button>
        </div>
    </form>
</ng-template>

<ng-template #contentupdate let-c="close" let-d="dismiss">
    <!-- (ngSubmit)="cardDetail(payment,content)" #payment="ngForm" -->
    <form [formGroup]="editCityForm" (ngSubmit)="onEditCity()">
        <div class="modal-header">
            <h4 class="modal-title" id="modal-basic-title">
                Update City
            </h4>
            <button type="button" class="btn-close" aria-label="Close" (click)="d('Cross click'); resetForm()">
                <svg xmlns="http://www.w3.org/2000/svg" width="24" height="25" viewBox="0 0 24 25" fill="none">
                    <rect y="0.696289" width="24" height="24" rx="12" fill="white" />
                    <path d="M6.99988 7.69653L12.0514 12.748L17.1029 7.69653" stroke="currentColor" stroke-width="1.6"
                        stroke-linecap="round" stroke-linejoin="round" />
                    <path d="M6.99995 18.3679L12.0505 13.3164L17.1021 18.3679" stroke="currentColor" stroke-width="1.6"
                        stroke-linecap="round" stroke-linejoin="round" />
                </svg>
            </button>
        </div>

        <div class="modal-body">
            <div class="row">
                <div class="col-md-12 form-styles my-3">
                    <label for="typeahead-basic">Region <span class="text-danger">*</span></label>
                    <ng-select [items]="regionList" bindLabel="name" bindValue="id" formControlName="region"
                        id="region" [loading]="regionLoading" loadingText="Loading regions..."></ng-select>
                    <small class="text-danger" *ngIf="
                            !editCityForm.get('region').valid &&
                            editCityForm.get('region').touched">
                        Please Select a Region</small>
                </div>
                <div class="col-md-12 mb-3 form-styles">
                    <label for="typeahead-basic">City <span class="text-danger">*</span></label>
                    <input id="typeahead-basic" type="text" class="form-control" formControlName="city"
                        maxlength="50" />
                    <small class="text-danger"
                        *ngIf=" editCityForm.get('city').hasError('required') && editCityForm.get('city').touched">Please
                        Enter City
                    </small>
                    <small class="text-danger" *ngIf="!editCityForm.get('city').hasError('required') &&
                        editCityForm.get('city').hasError('leadingWhitespace') &&                       
                        editCityForm.get('city').touched">
                        City cannot be empty.
                    </small>
                    <small class="text-danger" *ngIf="editCityForm.get('city').errors?.invalidInput">
                        CIty cannot be whitespace or only numbers.
                    </small>
                    <small class="text-danger" *ngIf="editCityForm.get('city').errors?.pattern">
                        City can only contain alphabetic characters.
                    </small>
                </div>
            </div>
        </div>
        <div class="modal-footer no-bg">
            <button type="button" class="btn btn-outline-dark" aria-label="Close"
                (click)="d('Cross click'); resetForm()">
                Cancel
            </button>
            <button type="button" class="btn btn-orange" [disabled]="editCityForm.invalid" (click)="d('Cross click')"
                type="submit">
                Save
            </button>
        </div>
    </form>
</ng-template>
<ng-template #modalDelete let-c="close" let-d="dismiss">
    <div class="modal-header">
        <h4 class="modal-title" id="modal-basic-title">
            DELETE
        </h4>
        <button type="button" class="btn-close" aria-label="Close" (click)="d('Cross click');">
            <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none">
                <rect width="24" height="24" rx="12" fill="white" />
                <path d="M7 7.00024L12.0515 12.0518L17.103 7.00024" stroke="currentColor" stroke-width="1.6"
                    stroke-linecap="round" stroke-linejoin="round" />
                <path d="M6.99995 17.6716L12.0505 12.6201L17.1021 17.6716" stroke="currentColor" stroke-width="1.6"
                    stroke-linecap="round" stroke-linejoin="round" />
            </svg>
        </button>
    </div>
    <div class="modal-body">
        <p class="text-center">Are you sure you want to delete this City?</p>
    </div>
    <div class="modal-footer no-bg">
        <button type="button" class="btn btn-outline-dark" aria-label="Close" (click)="d('Cross click')">
            Cancel
        </button>
        <button type="button" class="btn btn-orange" (click)="c('confirm')" type="submit">
            Delete
        </button>
    </div>
</ng-template>